export const EMAIL_HISTORY_COLUMNS = ["Email", "Registered On", "Status"];
